import {
    Component,
    OnInit,
    Inject,
    ChangeDetectorRef,
    ChangeDetectionStrategy
} from '@angular/core';
import { LoggingService } from '../shared/services/logging/logging.service';
import { AuthenticationService } from '../auth/authentication.service';
import { StateService } from '@uirouter/core';
@Component({
    selector: 'ef-login',
    styles: [
        `
                     .overlay {
                         position: absolute;
                         width: 100vw;
                         height: 100vh;
                         top: 0;
                         left: 0;
                         background-color: #333;
                         background-color: rgba(0, 0, 0, 0.5);
                     }
                 `
    ],
    template: ` <div class="overlay"></div> `,
    standalone: false
})
export class LoginComponent implements OnInit {
    constructor(
        @Inject(LoggingService) private log: LoggingService,
        @Inject(AuthenticationService) private auth: AuthenticationService,
        @Inject(StateService) private ss: StateService
    ) {}

    ngOnInit() {
        this.openDialog();
    }

    openDialog(): void {
        this.auth.openDialog();
    }
}
